import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/icons/user/user-account-circle-line/user-account-circle-line.component.js'

const tagName = 'dap-ds-icon-account-circle-line'

/**
 * `dap-ds-icon-account-circle-line`
 * @summary An icon
 * @element dap-ds-icon-account-circle-line
 * @title - UserAccountCircleLine
 * @group icon
 * @icontype user
 *
 * @attribute {number} size - (optional) The width and height in pixels
 * @attribute {boolean} selected - (optional) Sets the icon color via the `fill` attribute
 * @attribute {string} accessibilityTitle - (optional) When using the icon standalone, make it meaningful for accessibility
 * @attribute {boolean} focusable - (optional) If `true` the icon can receive focus
 *
 * @csspart base - The main icon container.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'UserAccountCircleLine',
})

export default reactWrapper
